import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import svg from "./image.gif";

ReactDOM.render(
  <div className="app">
    <img src={svg} className="img" alt="img" />
  </div>,
  document.getElementById("root")
);
